// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__3eu38","Label":"Input_Label__KeoAs","InputElement":"Input_InputElement__3bSgE","Invalid":"Input_Invalid__RWdEO","ErrorMessage":"Input_ErrorMessage__m3Tev"};